import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../_theme/helpers/components/KTIcon';

interface StepChangeAlertModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm?: () => void;
    onSave?: () => void;
    message?: string;
    popupLoader?: boolean;
    title?: string;
}

const StepChangeAlertModal: React.FC<StepChangeAlertModalProps> = ({
    show,
    onClose,
    onConfirm,
    onSave,
    message = '',
    popupLoader = false,
    title = 'Step change Confirmation',
}) => {
    return (
        <>
            <Modal
                show={show}
                onHide={onClose}
                dialogClassName='modal-dialog modal-dialog-centered'
                backdrop="static" keyboard={false}
            >
                <div className='modal-header pb-5'>
                    <h2>{title}</h2>
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose}>
                        <KTIcon className='fs-1' iconName='cross' />
                    </div>
                </div>
                <div className='modal-body text-center'>
                    <p className='fs-5'>{message}</p>
                </div>
                <Modal.Footer className='justify-content-center g-4'>
                    <Button variant='secondary' onClick={onClose}>
                        Cancel
                    </Button>
                    {onConfirm && <Button
                        variant='primary'
                        onClick={onConfirm}
                        disabled={popupLoader}
                    >
                        {popupLoader ? <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> : "Continue"}
                    </Button>}
                    {onSave && <Button
                        variant='success'
                        onClick={onSave}
                        disabled={popupLoader}
                    >
                        {popupLoader ? <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> : "Save & Continue"}
                    </Button>}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default StepChangeAlertModal;
